const pmsConfigs = {
    guesty: {
      name: "Guesty",
    },
    streamline: {
      name: "Streamline",
    },
    hospitable: {
      name: "Hospitable",
    },
    akia: {
      name: "Akia",
    },
    hostaway: {
      name: "Hostaway",
    },
    track: {
      name: "Track",
    },
        all: {
      name: "Guesty, Streamline, and Akia",
    },
    // Add more PMS platforms as needed
  };
  
  export default pmsConfigs;
  
